// apps/accounts/src/pages/staff/StaffStock.jsx
import { Navigate } from 'react-router-dom';

export default function StaffStock() {
  return <Navigate to="/staff/materials" replace />;
}